export default {
  uploads: (state) => {
    return state.uploads;
  },
  upload: (state) => {
    return state.upload;
  },
  uploadOptions: (state) => {
    const uploadOptions = [];
    state.uploads.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.fileId,
        image: item.filePath,
      };
      uploadOptions.push(pushItem);
    }
    return uploadOptions;
  },

  uploadInfo: (state) => {
    return state.uploadInfo;
  },

  excelTemplateHtml: (state) => {
    return state.excelTemplateHtml;
  },

  // Static Getters ---------------------------------------------------------------
  // uploadOptions() {
  //   return [
  //     { value: 1, image: "/emoji/happy.png" },
  //     { value: 2, image: "/emoji/happy-face.png" },
  //     { value: 3, image: "/emoji/neutral-face.png" },
  //     { value: 4, image: "/emoji/sad-face.png" },
  //     { value: 5, image: "/emoji/smile.png" },
  //   ];
  // },
};
